import { render, staticRenderFns } from "./EditMetadataModal.vue?vue&type=template&id=4bd11dc3&"
import script from "./EditMetadataModal.vue?vue&type=script&lang=js&"
export * from "./EditMetadataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports